import * as React from 'react';
import {reduxForm, Field, formValueSelector} from 'redux-form';
import {Button, Row, Col, Modal as BootstrapModal} from 'react-bootstrap';
import './styles.scss';
import {flow} from 'lodash';
import {connect} from 'react-redux';
import {IStore} from '../../../../redux/IStore';
import {IQuoteState} from '../../../../services/quote/models';
import {isRequired} from '../../../../util/validators';
import {actions as quoteActions} from '../../../../services/quote/reducer';
import {IPolicy} from '../../../../data/api/models';
import FieldFormControl from '../../../../components/FieldFormControl';

const ModalHeader = BootstrapModal.Header;
const ModalTitle = BootstrapModal.Title;
const ModalBody = BootstrapModal.Body;
const ModalFooter = BootstrapModal.Footer;

interface IOwnProps {
    label: string;
    dispatch: any;
    policy: IPolicy;
    autoRenewalStatus: string;
}

interface IInjectedProps {
    quote: IQuoteState;
    submitSucceeded: any;
    handleSubmit: any;
    submitting: any;
    autoRenewalStatusReason: string;
    callback?: () => void;
    resource?: any;
}

interface INonAutoRenewalButtonState {
    showRenewalStateConfirmationModal: boolean;
    showRenewalStateModal: boolean;
    autoRenewalState: string;
    submitting: boolean;
}

type INonAutoRenewalButtonProps = IOwnProps & IInjectedProps;

export class NonAutoRenewalButton extends React.Component<INonAutoRenewalButtonProps, INonAutoRenewalButtonState> {
    public state = {
        showRenewalStateConfirmationModal: false,
        showRenewalStateModal: false,
        autoRenewalState: '',
        submitting: false,
    };

    public componentDidMount() {
        this.setState({
            autoRenewalState: this.props.autoRenewalStatus,
        });
    }

    public componentWillUpdate(newProps) {
        const {submitSucceeded, callback} = this.props;
        if (newProps.submitSucceeded && !submitSucceeded) {
            if (callback) {
                callback();
            }
            this.closeModal();
        }
    }

    public openModal = () => {
        this.setState({
            showRenewalStateModal: true,
        });
    }

    public closeModal = () => {
        this.setState({
            showRenewalStateModal: false,
        });
    }

    public closeConfirmModal = () => {
        this.setState({
            showRenewalStateConfirmationModal: false,
        });
    }

    private handleOpen = () => {
        const {autoRenewalStatus} = this.props;
        if ('manual' === autoRenewalStatus) {
            this.handleSubmit();
        } else {
            this.openModal();
        }
    }

    private onChangeReason = (event) => {
        const {dispatch} = this.props;

        dispatch(quoteActions.setAutoRenewalStatusReason(event.target.value));
    }

    private handleSubmit = () => {
        const {policy, autoRenewalStatus, autoRenewalStatusReason, dispatch} = this.props;
        let status = 'auto';

        if ('auto' === autoRenewalStatus) {
            status = 'manual';
        }

        this.setState({
            submitting: true,
        });

        const promise = new Promise((resolve, reject) => {
            resolve(dispatch(quoteActions.updateAutoRenewalStatus(
                policy.id,
                status,
                autoRenewalStatusReason)));
        });

        promise.then(() => {
            this.setState({
                autoRenewalState: status,
                submitting: false,
                showRenewalStateModal: false,
                showRenewalStateConfirmationModal: true,
            });
        });
    }

    private buttonCanShow = () => {
        const { policy } = this.props;

        if (policy && policy.metadata.product_code
            && ['CAMC', 'CSIS', 'TPL', 'CSS', 'CSSR'].includes(policy.metadata.product_code)) {
            return false;
        }

        let inAllowedTimePeriod = true;
        const auto = 'auto' === this.state.autoRenewalState;
        let allowedTime = 48;
        if (!auto) {
            allowedTime = 24;
        }

        if (!policy) {
            inAllowedTimePeriod = false;
        } else if (policy && policy.metadata.product_code === 'NPO') {
            const endDate: Date = new Date(policy.metadata.end_date);
            const now: Date = new Date();

            const diffInMs: number = endDate.getTime() - now.getTime();
            const diffInHours: number = diffInMs / (1000 * 60 * 60);

            if (diffInHours <= allowedTime && diffInHours >= 0) {
                inAllowedTimePeriod = false;
            }
        }

        return inAllowedTimePeriod;
    }

    public render() {
        if (!this.buttonCanShow()) {
            return null;
        }
        const {label, autoRenewalStatusReason} = this.props;
        const title = label || 'Non Auto Renewal';

        return (
            <div>
                <Row>
                    <Col xs={3}>
                        Auto Renewal
                    </Col>
                    <Col xs={3}>
                        {'auto' === this.state.autoRenewalState ? 'On' : 'Off'}
                    </Col>
                    <Col xs={6} className="info">
                        <div className="prevent-renewal-btn-wrapper pull-right">
                            <Button
                                bsStyle="primary"
                                label={title}
                                onClick={this.handleOpen}
                            >
                                Turn {'auto' === this.state.autoRenewalState ? 'Off' : 'On'} Auto Renewal
                            </Button>
                            <BootstrapModal
                                name={'quote'}
                                show={this.state.showRenewalStateModal}
                                onHide={this.closeModal} bsSize="large"
                            >
                                <ModalHeader closeButton={true}>
                                    <ModalTitle>
                                        Turn {'auto' === this.state.autoRenewalState ? 'Off' : 'On'} Auto Renewal
                                    </ModalTitle>
                                </ModalHeader>
                                <ModalBody>
                                    <Row className="renewal-form">
                                        <Col md={12} lg={12}>
                                            Please tell us your reasons for not renewing with us?
                                        </Col>
                                        <Col md={12} lg={12} onChange={this.onChangeReason}>
                                            <Field
                                                name="autoRenewalReason"
                                                type="radio"
                                                value="no-longer-required"
                                                complexValue={true}
                                                className="answer"
                                                component={FieldFormControl}
                                            >
                                                <div className="medical-btn yes">
                                                    I no longer require cover
                                                </div>
                                            </Field>
                                            <Field
                                                name={'autoRenewalReason'}
                                                type="radio"
                                                value={'cover-elsewhere'}
                                                complexValue={true}
                                                className="answer"
                                                component={FieldFormControl}
                                            >
                                                <div className="medical-btn yes">
                                                    I have cover elsewhere
                                                </div>
                                            </Field>
                                            <Field
                                                name={'autoRenewalReason'}
                                                type="radio"
                                                value={'too-expensive'}
                                                complexValue={true}
                                                className="answer"
                                                component={FieldFormControl}
                                            >
                                                <div className="medical-btn yes">
                                                    Too expensive
                                                </div>
                                            </Field>
                                            <Field
                                                name={'autoRenewalReason'}
                                                type="radio"
                                                value={'other'}
                                                complexValue={true}
                                                className="answer"
                                                component={FieldFormControl}
                                            >
                                                <div className="medical-btn yes">
                                                    Other
                                                </div>
                                            </Field>
                                            <Field
                                                name={`reason.otherReason`}
                                                type="text"
                                                value={'other'}
                                                placeholder="Reason"
                                                component={FieldFormControl}
                                                validate={
                                                    ['no-longer-required', 'cover-elsewhere', 'too-expensive']
                                                        .includes(autoRenewalStatusReason) ? [] : [isRequired]
                                                }
                                            />
                                        </Col>
                                    </Row>
                                </ModalBody>
                                <ModalFooter>
                                    <Button
                                        type="submit"
                                        bsStyle="primary"
                                        onClick={this.handleSubmit}
                                        disabled={this.state.submitting}
                                    >
                                        {title}
                                    </Button>
                                </ModalFooter>
                            </BootstrapModal>
                        </div>
                    </Col>
                </Row>
                <div>
                    <BootstrapModal
                        name={'confirmation'}
                        show={this.state.showRenewalStateConfirmationModal}
                        onHide={this.closeConfirmModal} bsSize="large"
                    >
                        <ModalHeader closeButton={true}>
                            <ModalTitle>Auto Renewal Confirmation</ModalTitle>
                        </ModalHeader>
                        <ModalBody>
                            The Auto Renewal Status Has Been Turned {'auto' === this.state.autoRenewalState ?
                            'On' : 'Off'}
                        </ModalBody>
                        <ModalFooter>
                            <Button
                                type="submit"
                                bsStyle="primary"
                                onClick={this.closeConfirmModal}
                            >
                                Continue
                            </Button>
                        </ModalFooter>
                    </BootstrapModal>
                </div>
            </div>
        );
    }
}

let selector;

export default flow([
    reduxForm({
        form: 'quote',
        destroyOnUnmount: false,
        forceUnregisterOnUnmount: true,
    }),
    (component) => {
        selector = formValueSelector('quote');
        return component;
    },
    connect((state: IStore) => {
        const autoRenewalStatusReason = selector(state, 'autoRenewalStatusReason');
        return {
            autoRenewalStatusReason,
            quote: state.quote,
        };
    }),
])(
    NonAutoRenewalButton as React.ComponentType<INonAutoRenewalButtonProps>,
);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/CustomerArea/components/NonAutoRenewalButton/index.tsx